// @flow

import BaseEventEmitter from "./Base";

class NodeEventEmitter extends BaseEventEmitter {}

export default NodeEventEmitter;
